const info = {
  ZH: { //中文翻译
    edit:'编辑',
    close:'关闭',
    details:"\u660E\u7EC6",
    use:"\u5E94\u7528",
    mds: " \u67E5\u770B\u6750\u6599\u6570\u636E\u8868",
    metarialdata: " \u67E5\u770B\u6750\u6599\u6570\u636E",
    com: " \u67E5\u770B\u96F6\u90E8\u4EF6",
    semicom: " \u67E5\u770B\u534A\u6210\u90E8\u4EF6",
    metarial: " \u67E5\u770B\u6750\u6599",
    modifyMds: " \u4FEE\u6539\u6750\u6599\u6570\u636E",
    clickRightTree: " \u8BF7\u70B9\u51FB\u5DE6\u8FB9\u6811\u8282\u70B9...",
    polymerRemark: "聚合物已被标注",
    polymerYes: " \u662F (\u5DF2\u6309\u7167\u6709\u5173\u89C4\u5B9A\u6807\u6CE8.)",
    polymerNo: " \u5426 (\u6CA1\u6709\u6309\u7167\u6709\u5173\u89C4\u5B9A\u6807\u6CE8.)",
    polymerNoApply: " \u4E0D\u9002\u7528 (\u6309\u7167\u6709\u5173\u89C4\u5B9A\u65E0\u987B\u6807\u6CE8.)",
    language_C: "\u4E2D\u6587",
    language_E: "\u82F1\u6587",
    language_F: "\u5916\u6587",
    mess_cicname: "\u96F6\u90E8\u4EF6\u540D\u79F0\u4E0D\u80FD\u4E3A\u7A7A\u6216\u542B\u6709\u7A7A\u683C\uFF01",
    mess_cicmeaWeightPerItem: "\u6D4B\u91CF\u6240\u5F97\u5355\u4E2A\u8D28\u91CF\u503C\u53EA\u80FD\u4E3A\u6B63\u6570\u4E14\u5C0F\u6570\u70B9\u540E\u53EA\u80FD\u4FDD\u5B586\u4F4D\uFF01",
    mess_cictolerance: "\u5141\u8BB8\u504F\u5DEE\u53EA\u80FD\u4E3A\u6B63\u6570\u4E14\u5C0F\u6570\u70B9\u540E\u53EA\u80FD\u4FDD\u5B586\u4F4D\uFF01",
    mess_cicmeaReuseRate: "\u6D4B\u91CF\u6240\u5F97\u53EF\u518D\u5229\u7528\u7387\u53EA\u80FD\u4E3A\u6B63\u6570\u4E14\u5C0F\u6570\u70B9\u540E\u53EA\u80FD\u4FDD\u5B586\u4F4D\uFF01",
    mess_cicmeaRecycleRate: "\u6D4B\u91CF\u6240\u5F97\u53EF\u56DE\u6536\u5229\u7528\u7387\u53EA\u80FD\u4E3A\u6B63\u6570\u4E14\u5C0F\u6570\u70B9\u540E\u53EA\u80FD\u4FDD\u5B586\u4F4D\uFF01",
    mess_name: "\u96F6\u90E8\u4EF6\u540D\u79F0\u4E0D\u80FD\u4E3A\u7A7A\u6216\u542B\u6709\u7A7A\u683C\uFF01",
    mess_meaWeightPerItem: "\u6D4B\u91CF\u6240\u5F97\u5355\u4E2A\u8D28\u91CF\u503C\u53EA\u80FD\u4E3A\u6B63\u6570\u4E14\u5C0F\u6570\u70B9\u540E\u53EA\u80FD\u4FDD\u5B586\u4F4D\uFF01",
    mess_tolerance: "\u5141\u8BB8\u504F\u5DEE\u53EA\u80FD\u4E3A\u6B63\u6570\u4E14\u5C0F\u6570\u70B9\u540E\u53EA\u80FD\u4FDD\u5B586\u4F4D\uFF01",
    mess_meaReuseRate: "\u6D4B\u91CF\u6240\u5F97\u53EF\u518D\u5229\u7528\u7387\u53EA\u80FD\u4E3A\u6B63\u6570\u4E14\u5C0F\u6570\u70B9\u540E\u53EA\u80FD\u4FDD\u5B586\u4F4D\uFF01",
    mess_meaRecycleRate: "\u6D4B\u91CF\u6240\u5F97\u53EF\u56DE\u6536\u5229\u7528\u7387\u53EA\u80FD\u4E3A\u6B63\u6570\u4E14\u5C0F\u6570\u70B9\u540E\u53EA\u80FD\u4FDD\u5B586\u4F4D\uFF01",
    mess_semiInseminameRoot: "\u534A\u6210\u54C1\u4EF6\u540D\u79F0\u4E0D\u80FD\u4E3A\u7A7A\u6216\u542B\u6709\u7A7A\u683C\uFF01",
    mess_semiInsemimeaReuseRateRoot: "\u6D4B\u91CF\u6240\u5F97\u53EF\u518D\u5229\u7528\u7387\u53EA\u80FD\u4E3A\u6B63\u6570\u4E14\u5C0F\u6570\u70B9\u540E\u53EA\u80FD\u4FDD\u5B586\u4F4D\uFF01",
    mess_semiInsemimeaRecycleRateRoot: "\u6D4B\u91CF\u6240\u5F97\u53EF\u56DE\u6536\u5229\u7528\u7387\u53EA\u80FD\u4E3A\u6B63\u6570\u4E14\u5C0F\u6570\u70B9\u540E\u53EA\u80FD\u4FDD\u5B586\u4F4D\uFF01",
    mess_semiInseminame: "\u534A\u6210\u54C1\u4EF6\u540D\u79F0\u4E0D\u80FD\u4E3A\u7A7A\u6216\u542B\u6709\u7A7A\u683C\uFF01",
    mess_semiInsemimeaReuseRate: "\u6D4B\u91CF\u6240\u5F97\u53EF\u518D\u5229\u7528\u7387\u53EA\u80FD\u4E3A\u6B63\u6570\u4E14\u5C0F\u6570\u70B9\u540E\u53EA\u80FD\u4FDD\u5B586\u4F4D\uFF01",
    mess_semiInsemimeaRecycleRate: "\u6D4B\u91CF\u6240\u5F97\u53EF\u56DE\u6536\u5229\u7528\u7387\u53EA\u80FD\u4E3A\u6B63\u6570\u4E14\u5C0F\u6570\u70B9\u540E\u53EA\u80FD\u4FDD\u5B586\u4F4D\uFF01",
    mess_semiInsemicminRate: "\u6BD4\u4F8B\u53EA\u80FD\u4E3A\u6B63\u6570\u4E14\u5C0F\u6570\u70B9\u540E\u53EA\u80FD\u4FDD\u5B586\u4F4D\uFF01",
    mess_semiInsemicmaxRate: "\u6BD4\u4F8B\u53EA\u80FD\u4E3A\u6B63\u6570\u4E14\u5C0F\u6570\u70B9\u540E\u53EA\u80FD\u4FDD\u5B586\u4F4D\uFF01",
    mess_semiInsemicrate: "\u6BD4\u4F8B\u53EA\u80FD\u4E3A\u6B63\u6570\u4E14\u5C0F\u6570\u70B9\u540E\u53EA\u80FD\u4FDD\u5B586\u4F4D\uFF01",
    mess_semicomname: "\u534A\u6210\u54C1\u4EF6\u540D\u79F0\u4E0D\u80FD\u4E3A\u7A7A\u6216\u542B\u6709\u7A7A\u683C\uFF01",
    mess_semicommeaReuserate: "\u6D4B\u91CF\u6240\u5F97\u53EF\u518D\u5229\u7528\u7387\u53EA\u80FD\u4E3A\u6B63\u6570\u4E14\u5C0F\u6570\u70B9\u540E\u53EA\u80FD\u4FDD\u5B586\u4F4D\uFF01",
    mess_semicommeaRecycleRate: "\u6D4B\u91CF\u6240\u5F97\u53EF\u56DE\u6536\u5229\u7528\u7387\u53EA\u80FD\u4E3A\u6B63\u6570\u4E14\u5C0F\u6570\u70B9\u540E\u53EA\u80FD\u4FDD\u5B586\u4F4D\uFF01",
    mess_semicomweight: "\u8D28\u91CF\u53EA\u80FD\u4E3A\u6B63\u6570\u4E14\u5C0F\u6570\u70B9\u540E\u53EA\u80FD\u4FDD\u5B586\u4F4D\uFF01",
    mess_metname: "\u6750\u6599\u540D\u79F0\u4E0D\u80FD\u4E3A\u7A7A\u6216\u542B\u6709\u7A7A\u683C\uFF01",
    mess_metcreuserate: "\u53EF\u518D\u5229\u7528\u7387\u53EA\u80FD\u4E3A\u6B63\u6570\u4E14\u5C0F\u6570\u70B9\u540E\u53EA\u80FD\u4FDD\u5B586\u4F4D\uFF01",
    mess_metcyclerate: "\u53EF\u56DE\u6536\u5229\u7528\u7387\u53EA\u80FD\u4E3A\u6B63\u6570\u4E14\u5C0F\u6570\u70B9\u540E\u53EA\u80FD\u4FDD\u5B586\u4F4D\uFF01",
    percent: "\u767E\u5206\u7387\u5FC5\u987B\u5C0F\u4E8E100%\uFF01",
    tdRfMscflag: "\u6750\u6599\u4EE3\u53F7/\u6807\u8BC6\u5F15\u7528\u6807\u51C6",
    tdRfMsccode: "\u6750\u6599\u4EE3\u53F7\u5F15\u7528\u6807\u51C6",
    msccheckCode: "\u68C0\u6D4B\u62A5\u544A\u7F16\u53F7",
    msccyclerate: "\u53EF\u56DE\u6536\u5229\u7528\u7387",
    simpleCheckBox1: "\u7B80\u5316\u6821\u9A8C\u89C4\u5219",
    msccreateDate: "\u521B\u5EFA\u65E5\u671F",
    msccheckDate: "\u68C0\u9A8C\u65E5\u671F",
    mscreleaseDate: "\u53D1\u5E03\u65E5\u671F",
    msctd: "\u6BD4\u4F8B",
    mscminRate: "\u4ECE",
    mscmaxRate: "\u5230",
    mscrate: "\u56FA\u5B9A",
    cicsymbol: "\u96F6\u90E8\u4EF6\u53F7\u4E0D\u80FD\u4E3A\u7A7A\uFF01",
    semiInsemisymbolRoot: "\u534A\u6210\u54C1\u4EF6\u53F7\u4E0D\u80FD\u4E3A\u7A7A\uFF01",
    metbol: "\u6750\u6599\u53F7\u4E0D\u80FD\u4E3A\u7A7A\uFF01",
    delSelf: " \u662F\u5426\u5220\u9664\u8BE5\u8282\u70B9?",
    noQuoteSelf: " \u4E0D\u80FD\u5F15\u7528\u81EA\u8EAB\u8282\u70B9\uFF01",
    quoteeErrorData: " \u5F15\u7528\u4E86\u4E0D\u6B63\u786E\u7684\u6570\u636E\!",
    noMutualQuote: " \u4E0D\u80FD\u76F8\u4E92\u5F15\u7528\!",
    sameSubstanceNoQuote: "\u4E0D\u80FD\u5728\u4E00\u4E2A\u8282\u70B9\u4E0B\u6DFB\u52A0\u76F8\u540C\u7269\u8D28\uFF01",
    savesuccess: " \u4FDD\u5B58\u6210\u529F\uFF01",
    savefailure: " \u4FDD\u5B58\u5931\u8D25\uFF01",
    transformModuleOK: " \u6B64MDS\u5C06\u5728\u4FDD\u5B58\u540E\u8F6C\u6362\u4E3A\u7EC4\u4EF6\u5355\u5143",
    transformModuleError: " \u6B64MDS\u65E0\u6CD5\u8F6C\u6362",
    saveNextPage: " \u60A8\u8FD8\u6CA1\u6709\u4FDD\u5B58\u6570\u636E\uFF0C\u662F\u5426\u5148\u4FDD\u5B58\uFF0C\u7136\u540E\u8FDB\u5165\u4E0B\u4E00\u9875\u9762?",
    createMds: " \u521B\u5EFA\u7684\u6750\u6599\u6570\u636E\u8868",
    com: " \u521B\u5EFA\u96F6\u90E8\u4EF6",
    average: " \u5E73\u5747\u503C",
    metarial: " \u521B\u5EFA\u6750\u6599",
    metarialdata: " \u521B\u5EFA\u6750\u6599\u6570\u636E",
    modifymetarialmds: " \u4FEE\u6539\u6750\u6599\u6570\u636E",
    clickRightTree: " \u8BF7\u70B9\u51FB\u5DE6\u8FB9\u6811\u8282\u70B9...",
    polymerRemark: " \u805A\u5408\u7269\u5DF2\u88AB\u6807\u6CE8",
    polymerYes: " \u662F (\u5DF2\u6309\u7167\u6709\u5173\u89C4\u5B9A\u6807\u6CE8.)",
    polymerNo: " \u5426 (\u6CA1\u6709\u6309\u7167\u6709\u5173\u89C4\u5B9A\u6807\u6CE8.)",
    polymerNoApply: " \u4E0D\u9002\u7528 (\u6309\u7167\u6709\u5173\u89C4\u5B9A\u65E0\u987B\u6807\u6CE8.)",
    mdsloading: " \u8BF7\u7A0D\u7B49...",
    mdssaving: " \u8BF7\u7A0D\u7B49...",
    btnModify: " \u4FEE\u6539",
    btnSetMetarial: " \u8BBE\u7F6E\u4E3A\u6807\u51C6\u6750\u6599",
    quoteMessage: " \u5F15\u7528\u4E2D,\u8BF7\u7B49\u5F85\u2026",
    backMds: " \u8FD4\u56DEMDS",
    mustSave: " \u8BF7\u5148\u4FDD\u5B58\u8BE5MDS\u7684\u4FE1\u606F\!",
    checkNum1: "\u8BF7\u8F93\u5165\u4E00\u4E2A\u4ECB\u4E8E0\u5230100\u4E4B\u95F4\u7684\u6B63\u503C(\u4F8B\u5982 0.25 \u6216 78.56)",
    checkNum3: "\u8BF7\u8F93\u5165\u4E00\u4E2A\u6B63\u6574\u6570\uFF08\u4F8B\u5982 198 \u6216 85\uFF09\u3002",
    checkNum2: "\u8BF7\u8F93\u5165\u4E00\u4E2A\u6B63\u503C(\u4F8B\u5982 312 \u6216 76.23)",
    semicom: "\u521B\u5EFA\u534A\u6210\u54C1\u4EF6",
    delNodeHsSame: "\u4E0D\u80FD\u5220\u9664\u5F53\u524D\u8282\u70B9\u3002\u56E0\u4E3A\u5220\u9664\u4E4B\u540E\uFF0C\u4F1A\u51FA\u73B0\u91CD\u590D\u7684\u8282\u70B9\u3002",
    altTypeDef: "\u540C\u7EA7\u8282\u70B9\u7C7B\u578B\u987B\u4FDD\u6301\u4E00\u81F4",
    altChangeType: "\u5B58\u5728\u540C\u7EA7\u8282\u70B9\u7C7B\u578B\u4E0D\u540C\u60C5\u51B5\uFF0C\u8BF7\u4FEE\u6539\uFF01",
    editmetflag: "\u9700\u4E3A\u6B64\u6750\u6599\u586B\u5199\u6750\u6599\u6807\u8BC6\uFF01",
    tmpreservedtitle: "\u4E34\u65F6\u4FDD\u7559\u533A",
    tmpreservedvalue: "\u6B64\u7269\u8D28\u5728\u62F7\u8D1D\u8FC7\u7A0B\u4E2D\u88AB\u5B58\u653E\u5728\u4E34\u65F6\u4FDD\u7559\u533A\uFF0C\u8BF7\u70B9\u51FB\u201C\u7F6E\u6362\u201D\u6309\u94AE\u6765\u66FF\u6362\u5B83\u3002",
    refSameNode: "\u4E0D\u80FD\u5728\u540C\u4E00\u8282\u70B9\u4E0B\u5F15\u7528\u76F8\u540C\u7684MDS\!",
    checkNum4: "\u6BD4\u4F8B\u6700\u5927\u503C\u5FC5\u987B\u5927\u4E8E\u6700\u5C0F\u503C",
    maxRate:'比例最大值（%）',
    option:'应用',
    applyTitle:"\u7981\u7528\u7269\u8D28\u5E94\u7528\u6807\u51C6",
    cancel:"取消",
    view:"显示",
    next:"下一步",
    doubleClick:"双击跳转到错误处",
    componentType:"零部件类型",
    Classification1:"一级分类",
    Classification2:"二级分类",
    Classification3:"三级分类",
    Classification4:"四级分类",
    approveMds:"批准",
    refused:"拒绝",
    mdsValidateActionConfirm:"\u5982\u679C\u662F\u6279\u51C6\u64CD\u4F5C\u5219\u6279\u51C6\u7684\u5185\u5BB9\u5C06\u65E0\u6CD5\u6062\u590D\uFF0C\u786E\u5B9A\u6267\u884C\u5417\uFF1F",
    AttachmentUpload:"附件上传",
    msg:"\u5728\u8FDB\u884C\u4E0B\u4E00\u6B65\u64CD\u4F5C\u524D\uFF0C\u6240\u6709\u5F53\u524D\u51FA\u73B0\u7684\u9519\u8BEF\u9700\u8981\u9884\u5148\u5F97\u5230\u4FEE\u6B63",
    deleteTips:'\u5220\u9664\u5F53\u524D\u8282\u70B9\u53CA\u5176\u5B50\u8282\u70B9',
    changeMdsMsg:'是否将此表单转换为材料数据表?',
    historicalApproval:"历史审批",
  },
  EN: { //英文翻译
    edit:'edit',
    close:'Close',
    details:"Details",
    use:"Application",
    mds: " view MDS",
    metarialdata: " view Material Data",
    com: " view Components",
    semicom: " view Semicomponent",
    metarial: " view Material",
    modifyMds: " Modify MDS",
    clickRightTree: " Please click one node on the left.",
    polymerRemark: " Polymeric part(s) have been marked.",
    polymerYes: " Yes(Parts marked as required on drawing.)",
    polymerNo: " No(Parts  not marked as required.)",
    polymerNoApply: " Not Applicable(Parts do not require marking due to specifications of weight,geometric restrictions or surface requirements)",
    language_C: "	Chinese",
    language_E: "	English",
    language_F: "	Foreign language",
    mess_cicname: "	The name of component can not be blank or contain space!",
    mess_cicmeaqualityPerItem: "	Measured quality per Item can only be a positive number and contain 6 digits after the decimal point!",
    mess_cictolerance: "	Tolerance can only be a positive number and contain 6 digits after the decimal point!",
    mess_cicmeaReuseRate: "	Measured recyclability rate can only be a positive number and contain 9 digits after the decimal point!",
    mess_cicmeaRecycleRate: "	Measured recoverability rate can only be a positive number and contain 7 digits after the decimal point!",
    mess_name: "	The name of component can not be blank or contain space!",
    mess_meaqualityPerItem: "	Measured quality per Item can only be a positive number and contain 7 digits after the decimal point!",
    mess_tolerance: "	Tolerance can only be a positive number and contain 6 digits after the decimal point!",
    mess_meaReuseRate: "	Measured recyclability rate can only be a positive number and contain 10 digits after the decimal point!",
    mess_meaRecycleRate: "	Measured recoverability rate can only be a positive number and contain 8 digits after the decimal point!",
    mess_semiInseminameRoot: "	Semicomponent name should not be blank or contain space!",
    mess_semiInsemimeaReuseRateRoot: "	Measured recyclability rate can only be a positive number and contain 11 digits after the decimal point!",
    mess_semiInsemimeaRecycleRateRoot: "	Measured recoverability rate can only be a positive number and contain 9 digits after the decimal point!",
    mess_semiInseminame: "	Semicomponent name should not be blank or contain space!",
    mess_semiInsemimeaReuseRate: "	Measured recyclability rate can only be a positive number and contain 12 digits after the decimal point!",
    mess_semiInsemimeaRecycleRate: "	Measured recoverability rate can only be a positive number and contain 10 digits after the decimal point!",
    mess_semiInsemicminRate: "	The rate can only be a positive number and contain 6 digits after the decimal point!",
    mess_semiInsemicmaxRate: "	The rate can only be a positive number and contain 6 digits after the decimal point!",
    mess_semiInsemicrate: "	The rate can only be a positive number and contain 6 digits after the decimal point!",
    mess_semicomname: "	Semicomponent name should not be blank or contain space!",
    mess_semicommeaReuserate: "	Measured recyclability rate can only be a positive number and contain 13 digits after the decimal point!",
    mess_semicommeaRecycleRate: "	Measured recoverability rate can only be a positive number and contain 11 digits after the decimal point!",
    mess_semicomweight: "	The quality can only be a positive number and contain 6 digits after the decimal point!",
    mess_metname: "The name of material can not be blank or contain space\! ",
    mess_metcreuserate: "	The recyclability rate can only be a positive number and contain 6 digits after the decimal point! can only be a positive number and contain 6 digits after the decimal point!",
    mess_metcyclerate: "	The recoverability rate can only be a positive number and contain 6 digits after the decimal point!",
    percent: "	The percentage must be less than 100%!",
    delSelf: " Are you sure delete this node?",
    noQuoteSelf: " Self-reference is not allowed.",
    quoteeErrorData: " The referenced data is not correct.",
    noMutualQuote: "  Mutual reference is not allowed.",
    sameSubstanceNoQuote: "A basic substance cannot be referenced twice or more in one node.",
    savesuccess: " Saved sucessfully!",
    savefailure: " Saved failure!",
    transformModuleOK: " This MDS will be converted to a module after save.",
    transformModuleError: " This MDS can't be converted to a module.",
    saveNextPage: " You have not saved your data yet , do you really want to save it and then jump to the next page?",
    createMds: " Ingredients",
    com: " Creation component",
    semicom: "  Creation semiComponent",
    metarial: " Creation material",
    metarialdata: " Created MDS",
    modifymetarialmds: " modify MDS",
    clickRightTree: " Please click one node on the left.",
    polymerRemark: " Polymeric part(s)  marked",
    polymerYes: " Yes(Parts marked as required on drawing.)",
    polymerNo: " No(Parts  not marked as required.)",
    polymerNoApply: " Not Applicable(Parts do not require marking due to specifications of weight,geometric restrictions or surface requirements)",
    mdsloading: " Please wait\u2026\u2026",
    mdssaving: " Please wait\u2026\u2026",
    btnModify: " Modify",
    btnSetMetarial: " convert to Standard Material",
    quoteMessage: " Referencing, please wait\u2026\u2026",
    backMds: " Back",
    mustSave: "Please save this mds first\!",
    detect: "Check",
    isdel: "Do you want to delete the node\u00A3\u00A1",
    tdRfMscflag: "Norms/Standards ",
    msccheckCode: "Test Report No.",
    msccyclerate: "Recoverability Rate",
    simpleCheckBox1: "Simplified check rules ",
    msccreateDate: "Creation date ",
    msccheckDate: "Check date ",
    mscreleaseDate: "Release date ",
    msctd: "Proportion",
    mscminRate: "From",
    mscmaxRate: "To",
    mscrate: "Fixed",
    mscResidualRate: "Rest",
    tdRfMsccode: "Norms/Standards",
    checkNum1: "Please enter a positive number between 0 to 100  (e.g. 0.25 or 78.56)",
    checkNum2: "Please enter a positive number(e.g. 312 or 76.23).",
    average: "Average",
    delNodeHsSame: "Node can not be deleted ,because  there would be duplicate nodes.",
    checkNum3: "Please enter a positive integer over 0 (e.g. 198 or 85).",
    altTypeDef: "Peer node type to be consistent",
    altChangeType: "Different node types exist at the same level, please revise\!",
    editmetflag: "You should fill Material Symbol for this material",
    'reachSvhc': "REACH-SVHC",
    tmpreservedtitle: "Temporary reserved area",
    tmpreservedvalue: "The substance has been stored in the temporary reserved area. Please use the \u201CReplace\u201D button to replace it.",
    refSameNode: "The MDS cannot be referenced more than once under the same node\!",
    checkNum4: "The maximum must be greater than minimum percentage values",
    maxRate:'%(MAX)',
    option:'Application',
    applyTitle:"prohibited substance application standard",
    cancel:"Cancel",
    view:"Display",
    next:"Next",
    doubleClick:"Double click to jump to the error",
    componentType:"Component Type",
    Classification1:"level1",
    Classification2:"level2",
    Classification3:"level3",
    Classification4:"level4",
    approveMds:"approve",
    refused:"refused",
    mdsValidateActionConfirm:"Are you sure to accept it? This operation can not be undone.",
    AttachmentUpload:"Attachment Upload",
    msg:"All existing errors need to be eliminated before any further processing may take place.",
    deleteTips:"Delete  this node and it's children",
    changeMdsMsg:'Press OK and the module will be converted to an MDS.',
    historicalApproval:'Historical Approval'
  }
}
export default info //需要暴露出去
